import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=b485e9d8&scoped=true"
import script from "./InsLayer.vue?vue&type=script&lang=ts"
export * from "./InsLayer.vue?vue&type=script&lang=ts"
import style0 from "./InsLayer.vue?vue&type=style&index=0&id=b485e9d8&prod&lang=less"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=b485e9d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485e9d8",
  null
  
)

export default component.exports